import { render } from "./BrowseCategories.vue?vue&type=template&id=28336188&scoped=true&ts=true"
import script from "./BrowseCategories.ts?vue&type=script&lang=ts"
export * from "./BrowseCategories.ts?vue&type=script&lang=ts"

import "./BrowseCategories.vue?vue&type=style&index=0&id=28336188&scoped=true&lang=scss"

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28336188"]])

export default __exports__